import React, { useCallback, useEffect, useState } from 'react';
import Swal from 'sweetalert2';
import toast from 'react-hot-toast';
import FullScreenLoader from '../Components/FullScreenLoader';

const Orders = () => {
  const [orders, setOrder] = useState([]);
  const [loading, setLoading] = useState(false);
  const [isOpen, setIsOpen] = useState(null);
    const BASE_URl = window.location.origin

  const fetchOrders = useCallback(() => {
    fetch(`${BASE_URl}/api/showOrders`, {
      method: 'GET',
      credentials: 'include',
    })
      .then((res) => res.json())
      .then((data) => {
        setOrder(data.orders || []);
      })
      .catch((error) => {
        console.log(error);
      });
  }, [BASE_URl]);

  const handleChangeStatus = async(e, id) => {
    e.preventDefault()
    const formData = {
      status: e.target.status.value
    }
    const result = await Swal.fire({
          title: "Are you sure?",
          text: "You won't be able to revert this!",
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#d33",
          cancelButtonColor: "#3085d6",
          confirmButtonText: "Do You want to change the status of the order",
        });


        if(result.isConfirmed){
          setLoading(true)
          fetch(`${BASE_URl}/api/changeStatus/${id}`, {
            method: "POST",
            credentials: 'include',
            headers: {
              'Content-Type': 'application/json'
            },
            body: JSON.stringify(formData)
          }).then((res) => res.json())
          .then((data) => {
            if(data&&data.sucess === true) {
              setLoading(false)
              fetchOrders()
              toast.success(data.messege)
            } else if(data && data.sucess === false) {
              setLoading(false)
              toast.error(data.message)
            }
          }).catch((error) => {
            setLoading(false)
            toast.error(error.message || 'Something Went Wrong')
          })
        }

    e.target.reset()
  }

  const fetchStoreToggle = useCallback(() => {
    fetch(`${BASE_URl}/api/showStoreToggle`, {
      method: 'GET',
      credentials: 'include',
    })
      .then((res) => res.json())
      .then((data) => {
        if (data.store && typeof data.store.isOpen !== 'undefined') {
          setIsOpen(data.store.isOpen);
        }
      })
      .catch((error) => {
        toast.error(error.message || 'Internal Server Error');
      });
  }, [BASE_URl]);

  useEffect(() => {
    fetchOrders();
    fetchStoreToggle();
  }, [fetchOrders, fetchStoreToggle]);

  const handleDeleteOrder = async (id) => {
    const result = await Swal.fire({
      title: 'Are you sure?',
      text: "You won't be able to revert this!",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#d33',
      cancelButtonColor: '#3085d6',
      confirmButtonText: 'Do You want to change the status of the order',
    });

    if (result.isConfirmed) {
      setLoading(true);
      fetch(`${BASE_URl}/api/deleteorder/${id}`, {
        method: 'DELETE',
        credentials: 'include',
      })
        .then((res) => res.json())
        .then((data) => {
          setLoading(false);
          if (data && data.sucess === true) {
            fetchOrders();
            toast.success(data.messege);
          } else {
            toast.error(data.messege);
          }
        })
        .catch((error) => {
          setLoading(false);
          toast.error(error.messege || 'Something Went Wrong');
        });
    }
  };

  const handleToggleForm = async (e) => {
    e.preventDefault();

    const formData = {
      isOpen: e.target.isOpen.value,
    };
    const isOpen = e.target.isOpen.value;
    const result = await Swal.fire({
      title: 'Are you sure?',
      text: `Do you want to ${isOpen === 'true' ? 'open' : 'close'} the Store?`,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#d33',
      cancelButtonColor: '#3085d6',
      confirmButtonText: 'Yes',
    });
    if (result.isConfirmed) {
      fetch(`${BASE_URl}/api/toggleStore`, {
        method: 'POST',
        credentials: 'include',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(formData),
      })
        .then((res) => res.json())
        .then((data) => {
          if (data && data.sucess === true) {
            fetchStoreToggle();
            toast.success(data.message);
          } else if (data && data.sucess === false) {
            toast.error(data.message);
          }
        })
        .catch((error) => {
          console.log(error);
          toast.error(error.message || 'Something Went Wrong');
        });
    }
  };


  return (
<div className="container mx-auto p-6 mt-14 mb-12">
      <h1 className="text-3xl font-bold text-center mb-8 text-gray-800">Manage Orders</h1>
      {loading?<FullScreenLoader/>:null}
      
      {/* Store Status Message */}
      <p className={`text-center text-lg font-semibold ${isOpen ? 'text-green-600' : 'text-red-600'}`}>
        Store is {isOpen ? "Open" : "Closed"}
      </p>
      
      {/* Store Status Form */}
      <div className="max-w-lg mx-auto bg-white shadow-md rounded-lg p-6 mb-8">
        <h2 className="text-lg font-semibold text-gray-700 mb-4">Open or Close the Store</h2>
        <form className="space-y-4" onSubmit={handleToggleForm}>
          <label className="block text-sm font-medium text-gray-700">Open or Close Store:</label>
          <select 
            name="isOpen"
            className="block w-full p-2 border rounded-md text-gray-700 bg-gray-100 focus:ring-2 focus:ring-indigo-400 cursor-pointer"
            defaultValue={isOpen ? "open" : "closed"}
          >
            <option value="true">Open</option>
            <option value="false">Closed</option>
          </select>
          <button type="submit" className="w-full px-4 py-2 bg-blue-500 text-white rounded-md hover:bg-blue-600 transition-all cursor-pointer">
            Submit
          </button>
        </form>
      </div>

      <div className="grid gap-8 sm:grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-3 justify-center">
        {orders && orders.length ?<>
          {orders.reverse().map((order, index) => (
          <div key={order._id} className="max-w-sm w-full p-6 bg-white shadow-xl rounded-2xl flex flex-col items-center space-y-6 border border-gray-200 transition-transform transform hover:scale-105">
            {/* Order Number */}
            <div className="text-center bg-gray-200 px-4 py-1 rounded-lg text-gray-700 font-bold">
              Order #{index + 1}
            </div>
            
            {/* User Image & Details */}
            <div className="flex flex-col items-center text-center">
              <img
                src={order.createdBy.profilePic.secure_url}
                alt="User"
                className="w-24 h-24 rounded-full border-4 border-gray-300"
              />
              <h2 className="text-lg font-semibold text-gray-800 mt-2">{order.createdBy.name}</h2>
              <p className="text-gray-500 text-sm">{order.adress}</p>
              <p className="text-gray-700 text-sm font-medium">Phone: {order.phone}</p>
            </div>
            
            {/* Item Image */}
            <div className="text-center">
              <img
                src={order.item.image.secure_url}
                alt={order.item.title}
                className="w-28 h-28 rounded-lg object-cover mx-auto"
              />
              <h3 className="text-md font-medium mt-3 text-gray-700">{order.item.title}</h3>
              <p className="text-gray-600 text-sm">Payment: {order.paymentMethod}</p>
            </div>
            
            {/* Order Status */}
            <div className={`text-center px-4 py-2 rounded-lg ${order.isCancled ? 'bg-red-200 text-red-600' : 'bg-gray-100 text-gray-700'}`}>
              {order.isCancled ? <p className="font-semibold">Order Cancelled</p> : <p className="font-semibold">Current Status: <span className="text-blue-600">{order.status}</span></p>}
            </div>
            
            {/* Status Form */}
            {!order.isCancled && (
              <form className="w-full text-center" onSubmit={(e) => {handleChangeStatus(e,order._id)}}>
                <label className="text-sm font-semibold text-gray-700 block mb-2">Update Status</label>
                <select
                  name='status'
                  className="block w-full p-2 border rounded-md text-gray-700 bg-gray-100 focus:ring-2 focus:ring-indigo-400 cursor-pointer"
                >
                  <option value="packing">Packing</option>
                  <option value="on the way">On the Way</option>
                  <option value="fulfilled">Fulfilled</option>
                </select>
                <button
                  type="submit"
                  className="w-full mt-3 px-4 py-2 bg-blue-500 text-white rounded-md hover:bg-blue-600 transition-all cursor-pointer"
                >
                  Submit
                </button>
              </form>
            )}
            
            {/* Delete Button */}
            <button
              onClick={() => handleDeleteOrder(order._id)}
              className="w-full px-4 py-2 bg-red-500 text-white rounded-md hover:bg-red-600 transition-all cursor-pointer"
            >
              Delete
            </button>
          </div>
        ))}
        </>:<h1>No Orders</h1>}
      </div>
    </div>
);
}


export default Orders;
